import React from 'react';
import { useIntl } from 'react-intl';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import SectionLayout from '../components/SectionLayout';
import NewsListItem from '../components/news/NewsListItem';
import { buttonVariants } from '../components/ui/Button';
import { getNewsItems, NEWS_DISPLAY_LIMIT } from '../content/news';

export default function News() {
  const intl = useIntl();
  const allNewsItems = getNewsItems();

  if (allNewsItems.length === 0) {
    return null;
  }

  const newsItems = allNewsItems.slice(0, NEWS_DISPLAY_LIMIT);

  return (
    <SectionLayout accent="none" background="white">
      <h2 className="section-title">
        {intl.formatMessage({ id: 'news.title' })}
      </h2>
      <p className="section-subtitle">
        {intl.formatMessage({ id: 'news.subtitle' })}
      </p>
      {intl.locale !== 'ja' && (
        <p className="mb-6 text-sm text-muted-foreground font-body">
          {intl.formatMessage({ id: 'news.languageNote' })}
        </p>
      )}
      <ul className="mt-2">
        {newsItems.map(item => (
          <NewsListItem
            key={item.id}
            item={item}
            showThumbnail={false}
            headingLevel="h3"
            compact
          />
        ))}
      </ul>
      <p className="mt-10 font-body">
        <Link
          to="/news/"
          className={buttonVariants({ className: 'gap-2 px-6 font-body' })}
        >
          {intl.formatMessage({ id: 'news.viewAll' })}
          <ArrowRight className="w-4 h-4 shrink-0" aria-hidden="true" />
        </Link>
      </p>
    </SectionLayout>
  );
}
